import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  acceptCoproduction,
  coproductionKeys,
  rejectCoproduction,
  removeCoproduction,
} from '@entities/partnership'

export function useAcceptCoproductionMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (token: string) => acceptCoproduction(token),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: coproductionKeys.mine() })
    },
  })
}

export function useRejectCoproductionMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (token: string) => rejectCoproduction(token),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: coproductionKeys.mine() })
    },
  })
}

export function useEndCoproductionMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => removeCoproduction(id),
    onSuccess: (invite) => {
      void queryClient.invalidateQueries({ queryKey: coproductionKeys.mine() })
      void queryClient.invalidateQueries({ queryKey: coproductionKeys.forProduct(invite.productId) })
    },
  })
}
